var $;

/**
 * Normalizes Croatian (HR) text by removing diacritics (special characters),
 * so accent-insensitive search becomes possible.
 *
 */
function normalizeHr(str) {
  if (!str) return '';
  return String(str)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D');
}


/**
 * Small, targeted variant expansion for Croatian diacritics.
 * Keeps request count low while covering common cases.
 */
function hrQueryVariants(term) {
  term = (term || '').trim();
  if (!term) return [];

  const base = normalizeHr(term);
  const variants = new Set([term, base]);

  const maps = [
    ['c', ['č', 'ć']],
    ['C', ['Č', 'Ć']],
    ['s', ['š']],
    ['S', ['Š']],
    ['z', ['ž']],
    ['Z', ['Ž']],
    ['d', ['đ']],
    ['D', ['Đ']]
  ];

  // Generate combinations by expanding step-by-step
  let current = new Set([base]);

  for (const [plain, diacs] of maps) {
    const next = new Set(current);

    for (const v of current) {
      if (!v.includes(plain)) continue;

      for (const d of diacs) {
        // replace ALL occurrences (important)
        next.add(v.split(plain).join(d));
      }
    }
    current = next;
  }

  for (const v of current) variants.add(v);

  // keep it bounded
  return Array.from(variants).slice(0, 8);
}

/**
 * Groups flat autocomplete results into Select2 optgroup format by location type.
 * Order: Regije → Destinacije → Mjesta → Vile
 *
 * @param {Array} data - flat array of autocomplete items
 * @returns {Array} - grouped array for Select2
 */
function groupByType (data) {
  var typeOrder = ['country', 'region', 'destination', 'city', 'Villa'];
  var groups = {};

  (data || []).forEach(function (item) {
    if (!item || !item.location_type) return;

    var type = item.location_type;
    if (!groups[type]) {
      groups[type] = {
        text: item.type_label || type,
        children: []
      };
    }
    groups[type].children.push(item);
  });

  var results = [];

  typeOrder.forEach(function (type) {
    if (groups[type] && groups[type].children.length > 0) {
      results.push(groups[type]);
    }
  });

  return results;
}

/**
 * Mark searched term in select2
 *
 * @param text
 * @param term
 * @param location_type
 * @returns {*|jQuery|HTMLElement}
 */
function markMatch (text, term, location_type) {
  var match = text.toUpperCase().indexOf(term.toUpperCase()),
    $result = $('<span></span>'),
    $match = $('<span class="select2-rendered__match"></span>');

  // If there is no match, move on
  if (match < 0) {
    return $result.text(text);
  }

  // Put in whatever text is before the match
  $result.text(text.substring(0, match));

  // Mark the match
  $match = $('<span class="select2-rendered__match"></span>');
  $match.text(text.substring(match, match + term.length));

  // Append the matching text
  $result.append($match);

  $result.attr('data-location-type', location_type);

  // Put in whatever is after the match
  $result.append(text.substring(match + term.length));

  return $result;
}

/**
 * Search submit validation
 * limit global search
 *
 * @returns {void}
 */
function searchSubmitValidation () {
  var submitButton = '.main-search-input__submit',
    submitForm = 'form#frm-homepageSearchForm, form#frm-searchResultsControl-filterFormControl-filterForm';

  $(submitButton).on('click', function (e) {
    e.preventDefault();
    appendButtonLoader();
    $(submitForm).submit();
  });
}

jQuery(document).ready(function ($) {
  var div = '<div>' + searchMessage + '</div>',
    searchLocation = '.main-search-input-item, .panel-dropdown--location',
    suggestedItem = '.select2-results__suggestion-item';

  $('body').on('click', '.select2-selection', function () {
    $('.select2-selection__choice__remove').trigger('click');
  });

  $('body').on('click', suggestedItem, function () {
    $this = $(this);

    $('.selectpicker').select2('trigger', 'select', {
      data: {
        id: $this.data('id'), text: $this.data('id')
      }
    });

    $('#search_location_type').val($this.data('location-type'));
    $('#search_location_code').val($this.data('location-code'));
  });

  /**
   *
   * @param params
   * @returns {{q: *}}
   */
  function select2Data (params) {
    return {
      q: normalizeHr(params.term),
      q_raw: params.term
    };
  }

  /**
   *
   * @param data
   * @returns {{results: *}}
   */
  function select2ProcessResults (data) {
    return {
      results: groupByType(data)
    };
  }

  $.fn.extend({
    select2Remote: function (url, options) {
      var props = {
        ajax: {
          url: url,
          data: select2Data,
          processResults: select2ProcessResults,
          delay: 250,
          transport: function (params, success, failure) {
            const rawTerm = params.data && (params.data.q_raw || params.data.q) ? (params.data.q_raw || params.data.q) : '';
            const variants = hrQueryVariants(rawTerm);

            // Make requests for each variant, merge unique results
            const requests = variants.map(v => {
              const p = $.extend(true, {}, params);
              p.data = $.extend({}, params.data, {
                q: v,
                q_raw: rawTerm
              });
              return $.ajax(p);
            });

            $.when.apply($, requests)
              .done(function () {
                const responses = (requests.length === 1)
                  ? [arguments[0]]
                  : Array.from(arguments).map(a => a[0]);

                // Your backend seems to return an array for Select2 (since processResults: results: data)
                const merged = [];
                const seen = new Set();

                responses.forEach(arr => {
                  (arr || []).forEach(item => {
                    // dedupe by id (preferred) else by text
                    const key = (item && item.id != null) ? String(item.id) : (item && item.text != null) ? String(item.text) : JSON.stringify(item);
                    if (!seen.has(key)) {
                      seen.add(key);
                      merged.push(item);
                    }
                  });
                });

                success(merged);
              })
              .fail(failure);

            return { abort: function () {} };
          }
        },
        width: '100%',
        tags: false,
        minimumInputLength: 3,
        placeholder: $(searchLocation).data('placeholder'),
        allowClear: false,
        language: {
          inputTooShort: function () {
            let $suggestedItems = [];

            suggestedItems.forEach(function (item, index, array) {
              let suggestedRegion = '';

              if (item.region) {
                suggestedRegion = ', ' + item.region;
              }

              if (index === 0) {
                $suggestedItems.push($('<p class="select2-results__suggestion-title">' + $(searchLocation).data('tooshort') + '</p>' +
                '<div class="select2-results__suggestion-list">'));
              }

              $suggestedItems.push($('<div class="select2-results__suggestion-item" data-id="' + item.name + suggestedRegion + '" data-location-type="' + item.location_type + '" data-location-code="' + item.location_code + '">' + item.name + suggestedRegion + '<span>' + item.country + '</span></div>'));


              if (item === array.length - 1) {
                $suggestedItems.push($('</div>'));
              }
            });

            return $suggestedItems;
          }
        }
      };
      if (options) {
        $.extend(true, props, options);
      }
      return this.select2(props);
    }
  });

  (function () {

    /**
     * Format AutoComplete
     *
     * @param item
     * @returns {jQuery|HTMLElement}
     */
    function formatAutocomplete (item) {
      if (item.children) {
        return $('<strong class="select2-group-label">' + item.text + '</strong>');
      }

      if (item.id === null || item.id === undefined) {
        return $(div);
      }

      var search_input_value = $('.select2-search__field').val();

      if (item.name) {
        var $wrapper = $('<div class="select2-item"></div>');
        var $name = markMatch(item.name, search_input_value, item.location_type);
        $name.addClass('select2-item__name');
        $wrapper.append($name);

        if (item.subtitle) {
          $wrapper.append($('<span class="select2-item__subtitle">' + item.subtitle + '</span>'));
        }

        return $wrapper;
      }

      return markMatch(item.id, search_input_value, item.location_type);
    }

    /**
     * format Selection
     *
     * @param item
     * @returns {jQuery|HTMLElement}
     */
    function formatSelection (item) {
      if (item.id === null || item.id === undefined) {
        return $('<div></div>');
      }

      if (item.location_type === undefined || item.location_code === undefined) {
        //default values
        $('#search_location_type').val($('#search_location_type').val());
        $('#search_location_code').val($('#search_location_code').val());
      } else {
        $('#search_location_type').val(item.location_type);
        $('#search_location_code').val(item.location_code);
      }


      return $('<span data-location-code="' + item.location_code + '" data-location-type="' + item.location_type + '" >' + item.id + '</span>');
    }

    function setControls () {
      $('.selectpicker').select2Remote(autocompleteLink, {
        templateResult: formatAutocomplete,
        templateSelection: formatSelection
      });
    }

    function Extension (naja) {
      naja.addEventListener('complete', function () {
        setControls();
      }.bind(this));
      return this;
    }

    naja.registerExtension(Extension);

    setControls();
  })();

  searchSubmitValidation();
});
